import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { fetchInvoices, fetchInvoice } from "../../actions/callrecorder/invoicesActions";
import { RootState } from "../index";

export interface InvoiceInterface {
  id: number;
  user_id: number;
  user_number_id: number | null;
  type_id: number;
  type_name: string | null;
  consume: boolean;
  amount: string | null;
  productid: string | null;
  original_transaction_id: string | null;
  created_at: string;
  updated_at: string;
  url: string;
}

const adapter = createEntityAdapter<InvoiceInterface>();

const invoicesSlice = createSlice({
  name: 'callrecorder_invoices',
  initialState: adapter.getInitialState({
    status: 'idle',
    error: null as string | null,
    count: 0
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoices.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.entities = action.payload.invoices;
        state.ids = action.payload.ids;
        state.count = action.payload.count;
      })
      .addCase(fetchInvoices.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || null;
      })

      .addCase(fetchInvoice.fulfilled, (state, action) => {
        const record = Object.values(action.payload.invoice)[0];
        state.entities[record.id] = record;
      })
  }
});

export const {
  selectById: selectInvoiceById,
  selectIds: selectInvoiceIds,
  selectEntities: selectInvoiceEntities,
} = adapter.getSelectors((state: RootState) => state.callrecorder.invoices);

export default invoicesSlice.reducer;
